module.exports = __webpack_public_path__ + "static/media/12.16d96c73.jpg";